import React, { useEffect, useRef } from 'react';


const internalstyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex:'1'
  },
  modal: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    position: 'relative',
    width: '80%',
    maxWidth: '500px'
  },
   alignBtns:{
    display:'flex',
    justifyContent:'flex-end',
  },
  closeButton: {
    color: '#fff',
    border: '1px solid #F63F40',
    cursor: 'pointer',
    height: 'auto',
    display: 'inline-block',
    padding: '0.5rem',
    fontSize: '1.125rem',
    minWidth: '114px',
    boxSizing: 'border-box',
    textAlign: 'center',
    transition: '0.5s',
    fontFamily: 'VodafoneRg-Regular',
    borderRadius: '5px',
    backgroundColor: '#F63F40',
    '&:hover':{
       backgroundColor:'#fff',
       color:'#F63F40'
    }
  },
      
  
}


// const ModelContent = ()=>{
//   return(
//      isOpen && (
//       <div style={internalstyles.overlay}>
//         <div
//           ref={modalRef}
//           onKeyDown={handleKeyDown}
//           role="button"
//           tabIndex="0"
//           style={internalstyles.modal}
//         >
//           {hasCloseBtn && (
//             <button type='button' style={internalstyles.closeButton} onClick={handleCloseModal}>
//               Close
//             </button>
//           )}
  
//           {children}
//         </div>
//       </div>
//     )
//   )
// }


const Modal = ({ isOpen, hasCloseBtn = true, onClose, children }) => {
  
  const handleCloseModal = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      handleCloseModal();
    }
  };

  // useEffect(() => {
  //   const modalElement = modalRef.current;
  //   console.log("🚀 ~ useEffect ~ modalElement:", modalElement)

  //   if (!modalElement) return;

  //   if (isOpen) {
  //     modalElement.showPreview();
  //   } else {
  //     modalElement.closePreview();
  //   }
  // }, [isOpen]);



  return (
    isOpen && (
      <div className='preview_templates' style={internalstyles.overlay}>
        <div  className='preview_templates_Wrapper'
          // ref={modalRef}
          onKeyDown={handleKeyDown}
          role="button"
          tabIndex="0"
          style={internalstyles.modal}
        >
          {hasCloseBtn && (
            <div style={internalstyles.alignBtns} className='alignBtns'>
              <button type='button' style={internalstyles.closeButton} onClick={handleCloseModal}>
                Close
              </button>
            </div>
          )}
  
          {children}
        </div>
      </div>
    )
  )
};





export default Modal;